module.exports = __webpack_public_path__ + "static/media/slide-3.ac7d0551.jpg";